import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetCobraByClientName = async (Id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_COBRA_BY_CLIENT_NAME + Id, token);
  return res;
};

export const UpdateCobra = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_COBRA, payload, token);
  return res;
};
